import React from 'react'
import { DateUtils } from 'react-day-picker'
import MomentLocaleUtils from 'react-day-picker/moment'
import moment from 'moment'
import 'moment/locale/pt-br'
import { Field } from 'redux-form'
import 'react-day-picker/lib/style.css'

import { RangeInput, Day, StyledCalendarPicker, Error, RangeInputWrapper } from './styles'

function renderDay(day) {
  return <Day>{day.getDate()}</Day>
}

const WEEKDAYS_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']

const validateRange = (rangeForValidation, value) => {
  if (value) {
    if (value.from !== undefined && value.to !== undefined) {
      const dateFrom = moment(value.from)
      const dateTo = moment(value.to)
      var diff = dateTo.diff(dateFrom, 'days')
      if (diff > rangeForValidation)
        return `Você só pode selecionar até ${rangeForValidation} dias para o período.`
    }
  }
  return undefined
}

export default function CalendarFilter(props) {
  function handleDayClick(day, fieldProps) {
    const range = DateUtils.addDayToRange(day, fieldProps.value)
    fieldProps.onChange(range)
  }

  return (
    <div>
      <Field
        name="rangeDates"
        type="text"
        validate={value => validateRange(props.rangeForValidation, value)}
        component={props => {
          const { from, to } = props.input.value
          const parsedDateFrom = `${moment(from).format('D')} de ${moment(from).format('MMMM')}`
          const parsedDateTo = `${moment(to).format('D')} de ${moment(to).format('MMMM')}`
          const modifiers = { start: from, end: to }

          return (
            <div>
              <RangeInputWrapper>
                <RangeInput
                  invalid={props.meta.error}
                  disabled
                  placeholder={`${from ? parsedDateFrom : `Data inicial`} / ${
                    to ? parsedDateTo : `Data final`
                  }`}
                />
                {props.meta.error && <Error>{props.meta.error}</Error>}
              </RangeInputWrapper>
              <StyledCalendarPicker
                renderDay={renderDay}
                numberOfMonths={2}
                selectedDays={[from, { from, to }]}
                modifiers={modifiers}
                onDayClick={day => {
                  handleDayClick(day, props.input)
                }}
                localeUtils={MomentLocaleUtils}
                locale="pt-br"
                weekdaysShort={WEEKDAYS_SHORT}
              />
            </div>
          )
        }}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/modules/FilterByPeriod/CalendarFilter/CalendarFilter.js